import { Box, Paper, Typography } from "@mui/material";

const TLRecurringJV = () => (
  <Box m={{ xs: 1.5, md: 3 }}>
    <Typography variant="h3" fontWeight={800}>Recurring JV</Typography>
    <Typography color="text.secondary" mb={2}>Manage recurring journal voucher schedules.</Typography>
    <Paper
      elevation={0}
      sx={{ minHeight: 420, p: 3, border: "1px solid", borderColor: "divider", borderRadius: 3 }}
    >
      <Typography color="text.secondary">The Recurring JV transaction list will be displayed here.</Typography>
    </Paper>
  </Box>
);

export default TLRecurringJV;
